<template>
  <div
    v-if="(desktop && desktop.file && !isMobile) || (desktop && desktop.file && (!mobile || !mobile.file) && isMobile)"
    class="responsive-background desktop"
    :src="resourceUrl + desktop.file.path"
    :style="{'background-image':'url(\'' + resourceUrl + desktop.file.path + '\')'}"
    alt
  ></div>
  <div
    v-else-if="mobile && mobile.file && isMobile"
    class="responsive-background mobile"
    :style="{'background-image':'url(\'' + resourceUrl + mobile.file.path + '\')'}"
    alt
  ></div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "responsive-background",
  props: {
    desktop: {
      required: true
    },
    mobile: {
      default: null
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "getIsMobile"
    })
  }
};
</script>
<style lang="scss" scoped>
</style>